<template>
        <div class="coursetest-notification-for-video">
            <div class="coursetest-notification-for-video__text-box">
                <p class="coursetest-notification-for-video__completed-text" v-html="getTextForCompletedCourse"></p>
                <p class="coursetest-notification-for-video__recommendation-text" v-html="getRecommendationForCourseTest"></p>
            </div>
            <div class="coursetest-notification-for-video__notification-buttons">
                <div class="coursetest-notification-for-video__next-button-container">
                    <TotemButton
                        v-if="isCollectionVideo"
                        size="large"
                        class="coursetest-notification-for-video__next-button"
                        color="dark"
                        @click="setNextVideo"
                        :label="$t('CourseVideo.redirection_countdown_next_part')"
                    >
                        <span class="icon-arrow-right"></span>
                    </TotemButton>
                    <TotemButton
                        v-if="enableRating"
                        icon="star-full"
                        size="small"
                        color="white"
                        @click="showRatingModal"
                        class='coursetest-notification-for-video__rating-button'
                        :label="ratingButtonLabel"
                    />
                </div>
            </div>
            <div>
                <TotemButton
                    size="medium"
                    @click="closeNotification"
                    :label="$t('General.close')"
                />
            </div>
        </div>
</template>

<script>
    import videoRedirections from 'components/shared/mixins/videoRedirections'
    import routeHelper from 'components/shared/mixins/routeHelper'
    import { mapGetters } from 'vuex'
    import microLearningHelper from 'components/shared/mixins/microLearningHelper'
    import courseTestHelper from 'components/shared/mixins/courseTestHelper'
    import courseRatingHelper from 'components/shared/global-courses-items/helper/course-rating-helper'

    export default {
        mixins: [
            videoRedirections,
            routeHelper,
            microLearningHelper,
            courseTestHelper,
            courseRatingHelper
        ],
        props: {
            isLastCollectionVideo: Boolean,
            isCollectionCoursePage: Boolean
        },
        data () {
            return {
                showCategories: false,
                showComponent: false
            }
        },
        computed: {
            ...mapGetters({
                course: 'Courses/getSingle',
                isRatingSaved: 'Ratings/getRatingSavedState'
            }),
            getTextForCompletedCourse () {
                return this.course.isTestAvailable ? this.$t('CourseVideo.completed_notification_with_test')
                    : this.$t('CourseVideo.completed_notification_no_test')
            },
            getRecommendationForCourseTest () {
                return this.course.isTestAvailable ? this.getRecommendationTextWhenTestAvailable
                    : this.getRecommendationTextWhenThereIsNoTest
            },
            getRecommendationTextWhenTestAvailable () {
                return this.isCollectionVideo ? this.$t('CourseVideo.mark_complete_recommendation_with_test')
                    : this.$t('CourseVideo.mark_complete_recommendation_with_test_non_collection')
            },
            getRecommendationTextWhenThereIsNoTest () {
                return this.isCollectionVideo ? this.$t('CourseVideo.mark_complete_recommendation_no_test')
                    : this.$t('CourseVideo.mark_complete_recommendation_no_test_non_collection')
            },
            isThereNextSectionAndItsVideo () {
                if (!this.isMicroLearningCourse || (this.isMicroLearningCourse && this.isCollectionCoursePage)) {
                    return true
                }
                return this.getNextSection() && this.getNextSection().type === 'video'
            },
            ratingButtonLabel () {
                return this.isRatingSaved ? this.$t('Rating.edit_your_rating_button') : this.$t('Rating.rate_this_course_button')
            },
            isCollectionVideo () {
                return this.isThereNextSectionAndItsVideo && !this.isLastCollectionVideo
            }
        },
        methods: {
            setNextVideo () {
                this.$emit('hideCourseTestNotification')
            },
            showRatingModal () {
                this.$modal.show('course-rating')
            },
            closeNotification () {
                this.$destroy()
                this.$el.parentNode.removeChild(this.$el)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .coursetest-notification-for-video {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        @include black(background, 0.9);
        z-index: 100;
        color: $white;
        font-size: 1.5rem !important;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background: linear-gradient(0deg, rgba(33, 33, 33, 0.90) 0%, rgba(33, 33, 33, 0.90) 100%);

        &__text-box {
            display: flex;
            align-items: center;
            flex-direction: column;
            font-size: 2.3rem;
            margin: 25px 60px;
            text-align: center;

            [class*="mobile"] & {
                font-size: 1.6rem;
                margin: 0 15px;
                padding: 20px 0 0 0;
            }
        }

        &__completed-text {
            margin: 10px 0;
            font-family: 'PlusJakartaSans-Bold', sans-serif;
        }

        &__notification-buttons {
            display: flex;
            margin: 0 100px;

            [class*="mobile"] & {
                margin: 0 15px;
            }
        }

        &__next-button-container {
            display: flex;
            flex-direction: column;
            position: relative;
            padding: 20px 0;
            font-family: 'PlusJakartaSans-Regular', sans-serif;
            margin-bottom: 10px;
        }

        &__next-button {
            padding: 0 30px !important;
            margin: 10px 0;
            .icon-arrow-right {
                font-size: 2rem !important;
                margin: 0 0 0 5px !important;
                padding: 0 !important;
            }
        }

        &__rating-button {
            margin: 10px 0;
            height: 40px;
        }
    }
</style>
